<template>
    <v-text-field v-bind="$attrs"
                  v-on="$listeners"
                  v-model="inputValue"
                  @wheel="$event.target.blur()"
                  class="mb-n2"
                  filled
                  style="zoom:0.8 ">
    </v-text-field>

</template>
<script>
    export default {
        props: {
            value: {
                type: String,
                required: true
            },
        },
        
        computed: {
            inputValue: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            },
        },
    }
</script>
